import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/backoffice',
    name: 'backoffice-layout',
    component: () => import('@/layouts/BackofficeLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'backoffice-dashboard',
        component: () => import('@/pages/backoffice/Dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sessions/:sessionNo',
        name: 'backoffice-session-show',
        component: () => import('@/pages/backoffice/SessionShow.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sessions/:sessionNo/additional-fee',
        name: 'backoffice-session-additional-fee',
        component: () => import('@/pages/backoffice/SessionAdditionalFee.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: "google-review/:sessionNo",
        name: "backoffice-google-review",
        component: () => import("@/pages/GoogleReview.vue"),
      },
      {
        path: 'orders/:orderNo',
        name: 'backoffice-multiple-session-qr',
        component: () => import('@/pages/backoffice/QrMultipleSession.vue'),
        meta: { requiresAuth: true }
      },
       {
        path: 'session-not-found',
        name: 'backoffice-session-not-found',
        component: () => import('@/pages/backoffice/SessionNotFound.vue'),
        meta: { requiresAuth: true }
      },
    ]
  }
]